// <-- Invoice Overview -->
export var Invoice = {
    chart:{
      type: "line",
      height: 450,
      foreColor: "#999",
      stacked: true,
      dropShadow: {
        enabled: true,
        enabledSeries: [0],
        top: -2,
        left: 2,
        blur: 5,
        opacity: 0.06
      },
      toolbar: {
          show:false,
        },
    },responsive: [
        {
          breakpoint:1470,
          options:{
            chart:{
              height:440
            }
          }
        },
        {
          breakpoint:1365,
          options:{
            chart:{
              height:300
            }
          }
        },
        {
          breakpoint:991,
          options:{
            chart:{
              height:250
            }
          }
        },
      ],
    colors:['#24695c', '#ba895d'],
    stroke:{       
      width:3
    },
    dataLabels: {
      enabled:false
    },
    series: [{
      name: 'Total Views',
      data: generateDayWiseTimeSeries(0, 18)
    }, {
      name: 'Unique Views',
      data: generateDayWiseTimeSeries(1, 18)
    }],
    markers: {
      size: 5,
      strokeColor: "#e3e3e3",
      strokeWidth: 3,
      strokeOpacity: 1,
      fillOpacity: 1,
      hover: {
        size: 6
      }
    },
    xaxis: {
      type: "datetime",
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      labels: {
        offsetX: 14,
        offsetY: -5
      },
      tooltip: {
        enabled: true
      },
      labels: {
          formatter: function (value) {
            return value + "k";
          },
        },
    },
    grid: {
      padding: {
        left: -5,
        right: 5
      }
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy"
      }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      show:false
    },
    fill: {
       type: "solid",
      fillOpacity: 0.7
    },
  };
  function generateDayWiseTimeSeries(s, count) {
    var values = [[
      4,3,10,9,29,19,25,9,12,7,19,5,13,9,17,2,7,5
    ], [
      2,3,8,7,22,16,23,7,11,5,12,5,10,4,15,2,6,2
    ]];
    var i = 0;
    var series = [];
    var x = new Date("11 Nov 2012").getTime();
    while (i < count) {
      series.push([x, values[s][i]]);
      x += 86400000;
      i++;
    }
    return series;
  }
// <-- Invoice Overview end-->

// <-- Yearlrgrowthchart data --> 
export var Yearlrgrowth = {
  series: [
    {
      name: "Yearly Profit",
      data: [
        {
          x: "2001",
          y: 5500
        },
        {
          x: "2002",
          y: 3800
        },
        {
          x: "2003",
          y: 5500
          
        },
        {
          x: "2004",
          y: 7700
        },
        {
          x: "2005",
          y: 1500
          
        },
        {
          x: "2006",
          y: 1000,
          fillColor: '#24695c',
        },
        {
          x: "2007",
          y: 5000,
          fillColor: '#24695c',
        },
        {
          x: "2008",
          y: 6000,
          fillColor: '#24695c',
        },
        {
          x: "2009",
          y: 7900,
          fillColor: '#24695c',
        },
        {
          x: "2010",
          y: 4700,
          fillColor: '#24695c',
        },
        {
          x: "2011",
          y: 4000,
          fillColor: '#24695c',
        },
        {
          x: "2012",
          y: 5000,
          fillColor: '#24695c',
        },
        {
          x: "2013",
          y: 7500
        },
        {
          x: "2014",
          y: 3500
        },
        {
          x: "2015",
          y: 4000
        },
        {
          x: "2016",
          y: 6500
        },
        {
          x: "2017",
          y: 4000
        },
        {
          x: "2018",
          y: 5853
        },
        {
          x: "2019",
          y: 6553
        },
        {
          x: "2020",
          y: 5200
        },
        {
          x: "2021",
          y: 6200
        },
        {
          x: "2022",
          y: 880,
          fillColor: '#ba895d',
        },
        {
          x: "2023",
          y: 1200,
          fillColor: '#ba895d',
        },
        {
          x: "2024",
          y: 8010,
          fillColor: '#ba895d',
        },
        {
          x: "2025",
          y: 6053,
          fillColor: '#ba895d',
        },
        {
          x: "2026",
          y: 4000,
          fillColor: '#ba895d',
        },
        {
          x: "2027",
          y: 1000,
          fillColor: '#ba895d',
        },
        {
          x: "2028",
          y: 6200
        },
        {
          x: "2029",
          y: 6200
        },
        {
          x: "2030",
          y: 7500
        },
        {
          x: "2031",
          y: 7000
        },
        {
          x: "2032",
          y: 5000
        },
        {
          x: "2033",
          y: 6000
        },
        {
          x: "2034",
          y: 8000
        },
        {
          x: "2035",
          y: 4000
        },
        {
          x: "2036",
          y: 4500
        },
        {
          x: "2037",
          y: 4800
        },
        {
          x: "2038",
          y: 3000,
          fillColor: '#ba895d',
        },
        {
          x: "2039",
          y: 4200,
          fillColor: '#ba895d',
        },
        {
          x: "2040",
          y: 7900,
          fillColor: '#ba895d',
        },
        {
          x: "2041",
          y: 4000,
          fillColor: '#ba895d',
        },
        {
          x: "2042",
          y: 5500,
          fillColor: '#ba895d',
        },
        {
          x: "2043",
          y: 1000
        },
        {
          x: "2044",
          y: 5500
        },
        {
          x: "2045",
          y: 7000
        },
        {
          x: "2046",
          y: 6500
        },
        {
          x: "2047",
          y: 4000
        }
        
      ]
    }
  ],
  chart: {
    height: 350,
    type: "bar",
    toolbar:{
      show:false,
    },
  },
  plotOptions:{
    bar:{
      horizontal:false,
      columnWidth:"70%",
    }
  },
  stroke: {
    show: false,
  },
  dataLabels: {
    enabled: false
  },
  fill: {
    opacity: 1
  },
  xaxis: {
    type: "datetime",
    axisBorder: {
      show: false
    },
    labels: {
          show: false,
        },
    axisTicks:{
        show:false,
     },
  },
   yaxis: {
    labels: {
      formatter: function (val) {
        return val / 100 + "K";
      },
    }
  },
  responsive: [
    {
      breakpoint:991,
      options: {
        chart: {
          height:250
        }
      }
    }
  ], 
  colors:["#d8e3e5"]
};
// <-- Yearlrgrowthchart data end --> 

// <-- column chart data -->
export var column =  {
  series: [{
  name: 'Inflation',
  data: [2.3, 5.1, 3.0, 9.1, 2.0, 4.6, 2.2, 9.3, 5.4, 4.8, 3.5, 5.2,2.3, 5.1, 3.0, 9.1, 2.0, 4.6, 2.2, 9.3, 5.4, 4.8, 3.5, 5.2]
  // data: [4.3, 5.1, 3.0, 8.1, 3.0, 5.6, 3.2]
}],
  chart: {
  height:90,
  type: 'bar',
  toolbar: {
      show: false
   },
},
plotOptions: {
     bar: {
      dataLabels: {
        position: 'top', // top, center, bottom
      },

     columnWidth: '20%',
     startingShape: 'rounded',
     endingShape: 'rounded',
     colors: {
backgroundBarColors: ["#d8e3e5"],
backgroundBarOpacity: 1,
backgroundBarRadius: 9
},
  }
},
dataLabels: {
  enabled: false,
  formatter: function (val) {
    return val + "%";
  },
  offsetY: -10,
  style: {
    fontSize: '12px',
    colors: ["#912efc"]
  }
},

xaxis: {
  categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  position: 'bottom',

  axisBorder: {
    show: false
  },
  axisTicks: {
    show: false
  },
  crosshairs: {
    fill: {
      type: 'gradient',
      gradient: {
        colorFrom: '24695c',
        colorTo: '#c481ec',
        stops: [0, 100],
        opacityFrom: 0.4,
        opacityTo: 0.5,
      }
    }
  },
  tooltip: {
    enabled: true,
  },
  labels:{
    show:false
  }

},
yaxis: {
  axisBorder: {
    show: false
  },
  axisTicks: {
    show: false,
  },
  labels: {
    show: false,
    formatter: function (val) {
      return val + "%";
    }
  }
},
 colors: ['#ba895d'],

};
// <-- column chart data end -->

// <-- Total selling chart data -->
export var Totalselling = {
  series: [{
  name: 'TEAM A',
  type: 'area',
  data: [44, 48, 38, 47]
}, {
  name: 'TEAM B',
  type: 'line',
  data: [42, 38, 48, 30]
}],
  chart: {
  height:470,
  type: 'line',
  toolbar: {
    show:false,
  },

},
stroke: {
  curve: 'smooth',
  width: [5, 2],
  dashArray: [0, 8]
  
},
fill: {
  type:'solid',
  opacity: [0.35, 1],
},
labels: ['2010', '2011','2012','2013'],
markers: {
  size: 5
},
responsive: [
  {
    breakpoint:991,
    options: {
      chart: {
        height:300
      }
    }
  },
  {
    breakpoint:1501,
    options: {
      chart: {
        height:325,
      }
    }
  }
],
yaxis: [
  {
     labels: {
        formatter: function (value) {
          return value + "k";
        },
      },
  },
],
tooltip: {
  shared: true,
  intersect: false,
  y: {
    formatter: function (y) {
      if(typeof y !== "undefined") {
        return  y.toFixed(0) + " points";
      }
      return y;
    }
  }
},
legend: {
    show:false,
   },
   colors:['#24695c' , '#ba895d']
};
// <-- Total selling chart data end-->